"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var REAGAN_MAJOR_VERSION = exports.REAGAN_MAJOR_VERSION = 6;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/Reagan/static-6.24/coffee/constants.js
// module id = 584
// module chunks = 0